// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { $state, $stateParams } from '../../../router';

// Components
import { 
	GECKO_CONSTS,
	GeckoBtn,
	GeckoModalService,
} from '@geckolabs/gecko-react-ui';
import Card from '../../Card';
import GuestCountModal from '../../../pages/rsvp/components/GuestCountModal';

// Services
import Utils from '../../../services/utils/utils';
import { __, STR_KEY } from '../../../services/Translate';

const DEFAULT_SOURCE_ITEM = {
	label: '',
	icon: null,
	iconProps: {},
	onClick: () =>{},
	width: null,
	className: '',
};

export default class ProfileCalendarBtns extends Component {

	state = {
		attendances_count: null,
	}

	handler(link, gaEvent) {
		return window.location.href = link;
	}

	print() {
		return window.print();
	}

	allEvents()
	{
		$state.go('id', $stateParams);
        return;
	}

    openGuestCountModal() {
    	return new GeckoModalService().open(()=>{
            return (
                <GuestCountModal {...this.props}/>
            );
        }, {labelledBy: 'field_attendances_count_label'});
    }

	dataSource = [
		{
			label: __(STR_KEY.BTN_GUESTS),
			id: 'guests',
			icon: 'users',
			onClick: () => {
				// Do not remove the parent brackets, this is an accessibility change
				// that will focus on the original element after the modal is closed
				this.openGuestCountModal()
			},
			className: 'btnAction',
			hideWhen: () => {
				return !this.props.event.maximum_guests || this.props.event.delivery_method === 'online';
			}
		},
		{
			label: __(STR_KEY.BTN_CALENDAR),
			id: 'add-to-calendar',
			icon: 'fa-calendar-plus far',
			onClick: () => this.handler(this.props.ical, 'iCal'),
			hideWhen: () => {
				return !this.props.ical;
			},
			role: 'link'
		},
		{
			label: __(STR_KEY.BTN_ALL_EVENTS),
			id: 'all-events',
			icon: 'list',
			onClick: () => this.allEvents(),
			isLink: true
		},
		{
			label: __(STR_KEY.BTN_PRINT),
			id: 'print',
			icon: 'print',
			onClick: () => this.print(),
			hideWhen: () => {
				return this.props.event.delivery_method === 'online';
			}
		},
		{
			label: __(STR_KEY.BTN_WALLET),
			id: 'add-to-wallet',
			icon: 'fa-apple',
			iconProps: {style: 'brand'},
			onClick: () => this.handler(this.props.passbook, 'Apple Wallet'),
			hideWhen: () => {
				return !this.props.passbook || this.props.event.delivery_method === 'online';
			}
		},
	];

	shouldRenderAction(item)
	{
		if (item.hideWhen) {
			return !item.hideWhen();
		}

		return true;
	}

	renderActionButton(item)
	{
		return (
			<GeckoBtn 
				name={item.label}
				id={item.id}
				icon={item.icon}
				iconProps={item.iconProps}
				type={GECKO_CONSTS.BTN_TYPE_DEFAULT}
				handler={item.onClick}
				{... item.role && {role: item.role}}
			/>	
		)
	}

	renderActionLink(item)
	{
		const handleOnKeyDown = (event) => {
			// 'Enter' keycode
			if ([13].includes(event.keyCode)){
				item.onClick();
			}
		}

		return (
			<span
				role="link" 
				className="gecko-ui-btn btn-secondary btn" 
				onClick={item.onClick}
				tabIndex="0"
				aria-label={item.label}
				target="_self"
				onKeyDown={handleOnKeyDown}
				>
				<span className="gecko-ui-icon far fa-list mr-2"></span>
				{item.label}
			</span>
		)
	}

	renderAction(item, key)
	{
		if (this.shouldRenderAction(item)) {
			const width = 'col-xs-12 ' + (item.width ? item.width : 'col-sm-6');
			const rendered = item.isLink ? this.renderActionLink(item) : this.renderActionButton(item);
			return (
				<div key={key} className={width}>
					{rendered}
				</div>
			);
		}

		return null;
	}

	renderItems()
	{
		return this.dataSource.map((item, key) => {
			const preparedItem = this.prepareItem(item);
			return this.renderAction(preparedItem, key);
		})
	}

	prepareItem(item)
	{
		return Object.assign({}, DEFAULT_SOURCE_ITEM, item);
	}

    render() {
		return (
			<Card className="control-btns-container">
	            <div className="profileCalendarBtns">
	            	<div className="row">
	            		{this.renderItems()}
	            	</div>
	            </div>
            </Card>
        );
    }
}

ProfileCalendarBtns.propTypes = {
    ical: PropTypes.string,
    passbook: PropTypes.string,
    event: PropTypes.object,
};

ProfileCalendarBtns.defaultProps = {
  	event: {},
};